import { CallState } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { TaskState } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import { setOutboundCallToAccepted } from '../callHandlers/outboundCalls';
import { setInternalCallToAccepted } from '../callHandlers/internalCalls';

function handleCallAnswered(_context: InboxContext, event: CallState) {
  // if this is an outbound or internal call, then we should mark
  // the task as accepted
  const task = TasksModule.getTask(event.pcsConversationSid);

  if (!task || task.state !== TaskState.Offered) {
    return;
  }

  if (task.isOutbound) {
    setOutboundCallToAccepted(_context, event.pcsConversationSid);
  } else if (task.isInternal) {
    setInternalCallToAccepted(_context, event.pcsConversationSid);
  }
}

export default handleCallAnswered;
